<template>
  <div class="props-group attr-label-content">
    <el-form-item label="" label-width="0">
      <div>
        <span>标签内容&nbsp;</span>
        <el-tooltip content=" 可采用富文本编辑，填写者看到的内容将与您编辑的内容一致" placement="right-end" popper-class="attr-label-content-tooltip">
          <span class="remind-icon"></span>
        </el-tooltip>
      </div>
      <div class="editor" ref="editor"></div>
    </el-form-item>
  </div>
</template>

<script>
import Editor from 'wangeditor'
import tokenStorage from '@/plugins/tokenStorage'
export default {
  name: 'attr-label-content',
  props: ['component'],
  inject: ['formService', 'componentEventBus'],
  data () {
    return {
      editor: undefined,
      value: ''
    }
  },
  methods: {
    initRichBox () {
      let self = this
      let token = tokenStorage.getToken()
      this.editor = new Editor(this.$refs.editor)
      this.editor.customConfig.showLinkImg = false
      this.editor.customConfig.zIndex = 100
      // 自定义处理粘贴的文本内容
      this.editor.customConfig.pasteTextHandle = function (content) {
        // content 即粘贴过来的内容（html 或 纯文本），可进行自定义处理然后返回
        if (content === '' && !content) return ''
        let str = content
        // 处理的标签里的多余代码
        str = str.replace(/<xml>[\s\S]*?<\/xml>/ig, '')
        str = str.replace('/(\\n|\\r| class=(")?Mso[a-zA-Z]+(")?)/g', '')
        let reg = new RegExp('<!--(.*?)-->', 'g')
        str = str.replace(reg, '')
        return str
      }
      // 定义图片接受file name 名称后台定义的file
      this.editor.customConfig.uploadFileName = 'image'
      this.editor.customConfig.uploadImgHeaders = {
        'Authorization': token
      }
      this.editor.customConfig.uploadImgServer = '/shared-api/files/uploadImage'
      this.editor.customConfig.uploadImgParams = {type: 'USER'}
      this.editor.customConfig.uploadImgHooks = {
        error (xhr, editor) {
          this.$message.error('上传失败')
        },
        customInsert (insertImg, result, editor) {
          let url = self.getDownLoadUrl(result.data)
          insertImg(url)
        }
      }
      this.editor.customConfig.onchange = html => {
        this.value = html
      }
      this.editor.customConfig.menus = [
        'bold', // 粗体
        'italic', // 斜体
        'underline', // 下划线
        'strikeThrough', // 删除线
        'quote', // 引用
        'undo', // 撤销
        'redo', // 重复
        'link', // 插入链接
        'head', // 标题
        'fontSize', // 字号
        'fontName', // 字体
        'foreColor', // 文字颜色
        // 'backColor', // 背景颜色
        'list', // 列表
        'justify', // 对齐方式
        // 'emoticon', // 表情
        'table', // 表格
        // 'video', // 插入视频
        // 'code', // 插入代码
        'image' // 插入图片
      ]
      this.editor.create()
      this.$nextTick(() => {
        this.value = this.component.properties.labelContent
        this.editor.txt.html(this.component.properties.labelContent)
      })
    },
    getDownLoadUrl (path) {
      return path.includes('USER') ? sessionStorage.getItem('ossDownloadUrl') + path : path.includes('SYSTEM') ? sessionStorage.getItem('ossDownloadUrl') + path : path
    }
  },
  mounted () {
    this.initRichBox()
    this.componentEventBus.$on('changeLeftPanel', ({save, id}) => {
      if (save === 0) {
        this.component.properties.labelContent = this.value
        this.formService.updateAttr(this.component)
      }
      // 切换控件
      if (save === 2) {
        this.$nextTick(() => {
          this.value = this.component.properties.labelContent
          this.editor.txt.html(this.component.properties.labelContent)
        })
      }
    })
  }
}
</script>

<style lang="scss">
  .attr-label-content {
    .el-form-item {
      .el-tooltip {
        margin-bottom: 2px;
      }
      /* 修改 wangeditor 自带的样式 */
      .editor {
        width: calc(100% + 20px);
        margin-top: 2px;
        margin-left: -10px;
        .w-e-text-container{
          width: 192px !important;
          height: 185px !important;
          border-color: #ECECEC!important;
        }
        .w-e-toolbar {
          background-color: #fff!important;
          flex-wrap: wrap !important;
          -webkit-border-radius: 4px 4px 0 0;
          -moz-border-radius: 4px 4px 0 0;
          border-radius: 4px 4px 0 0;
          border-color: #ECECEC!important;
          .w-e-menu {
            padding: 0;
            width: 24px;
            height: 20px;
            line-height: 18px;
            font-size: 10px;
            vertical-align: bottom;
            display: inline-block;
            .w-e-droplist {
              background-color: #fff;
            }
            & > i {
              font-size: 12px;
            }
            .w-e-icon-header {
              font-size: 10px;
            }
          }
        }
        .w-e-text-container {
          -webkit-border-radius: 0 0 4px 4px;
          -moz-border-radius: 0 0 4px 4px;
          border-radius: 0 0 4px 4px;
          width: 100% !important;
          .w-e-text {
            width: calc(100% + 20px) !important;
          }
          .w-e-panel-container{
            width: 100%!important;
            right: 0!important;
            left: 100% !important;
            margin-left: -100%!important;
          }
        }
      }
    }
  }
  .attr-label-content-tooltip {
    width: 200px;
    -ms-word-wrap: break-word;
    word-wrap: break-word;
    padding: 6px 7px;
  }
</style>



// WEBPACK FOOTER //
// src/components/form/componentAttr/label-content.vue